import React from "react";
import { Form } from "@redriver/cinnamon";
import { getCustomerTypes } from "./actions";

const CustomerTypesDropdown = (props) => (
  <Form.Dropdown {...props} lookupAction={getCustomerTypes} />
);

export default CustomerTypesDropdown;
